import { Button, Tooltip } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useFormikContext } from 'formik';
import React, { useCallback, useEffect, useState } from 'react';
import { useObservable } from 'react-use-observable';
import salesService from 'v2/services/sales/general';

import Item from './item';
import AdvancedButton from '../AdvancedButton';
import { ChargeTypes, DateTypes, GainTypes, InitialFilter, InvoiceStatus, OriginSales, PaymentTypes } from '../interfaces';

import type IFilter from '../interfaces';

const useStyle = makeStyles((theme) => ({
  root: {},
  title: {
    fontSize: '2rem',
    lineHeight: 1,
    fontWeight: 200,
    display: '1',
    '& p': {
      fontSize: '1.2rem',
      fontWeight: 400,
      lineHeight: '1.3125rem',
      marginBottom: theme.spacing(2),
      width: '100%',
    },
  },
  result: {
    //color: '#596375',
    border: '2px dashed #596375',
    background: 'white',
    borderRadius: 4,
    padding: theme.spacing(2),
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    cursor: 'pointer',
  },
  tags: {
    cursor: 'pointer',
    display: '1',
    width: '90%',
    '&:hover': {
      opacity: '80%',
    },
  },
  buttonReset: {
    display: '2',
    width: '10%',
  },
  tooltip: {
    cursor: 'pointer',
  },
}));

const ResultFilter = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { resetForm } = useFormikContext<IFilter>();
  const classes = useStyle({});

  const [productsFormated, setProductFormated] = useState<any[]>([]);

  const [filter] = useObservable(() => salesService.getFilter(), []);

  const onOpenAdvanced = useCallback(() => {
    salesService.setFilterIsAdvanced(true);
  }, []);

  const [products] = useObservable(() => {
    return salesService.getProducts();
  }, []);

  const [coupons] = useObservable(() => {
    return salesService.getCoupons();
  }, []);

  const resetFilter = useCallback(() => {
    salesService.setFilter(InitialFilter);
    resetForm({ values: InitialFilter });
    const np = products.map((prod: any) => {
      prod.checked = false;
      prod.children = prod.children.map((p: any) => {
        p.checked = false;
        return p;
      });
      return prod;
    });
    salesService.setProducts(np);
  }, [products, resetForm]);

  useEffect(() => {
    const pc = products && Array.isArray(products) ? products.filter((prod: any) => prod.checked) : [];
    const sp = pc
      .map((p: any) => ({ label: `${p.id} - ${p.title}`, value: p.id }))
      .concat(
        (products || [])
          .reduce((pd: any, { children }) => pd.concat(children), [])
          .filter((c: any) => c.checked)
          .map((p: any) => ({ label: `${p.id} - ${p.title}`, value: p.id }))
      );
    setProductFormated(sp);
  }, [products]);

  const selectedAffiliatesSize = filter?.affiliates?.length;
  const formattedAffiliatesNames =
    selectedAffiliatesSize >= 3 || isMobile ? `${selectedAffiliatesSize} selecionados` : filter?.affiliates?.map((a) => a.name).join(', ');

  return (
    <div className={classes.root}>
      <span className={classes.title}>
        <p>Filtros Aplicados</p>
      </span>

      <div className={classes.result}>
        {filter && (
          <Tooltip className={classes.tooltip} title='Clique para editar os filtros'>
            <div className={classes.tags} onClick={onOpenAdvanced}>
              <Item label={'Tipo de data'} value={filter.date_type} alias={DateTypes} />
              <Item label={'Data'} value={`${filter.date[0]} ~ ${filter.date[1]}`} />
              {filter.customer && (
                <>
                  {/* <Item label={'Cliente por'} value={filter.customer_type} alias={CustomerTypes} /> */}
                  <Item label={'Cliente'} value={filter.customer} />
                </>
              )}
              <Item label={'Fatura'} value={filter.invoice_id} />
              <Item label={'Status da fatura'} value={filter.payment_status} alias={InvoiceStatus} />
              <Item label={'Produto'} value={filter.product_id} alias={productsFormated} />
              <Item label={'Tipo de pagamento'} value={filter.payment_method} alias={PaymentTypes} />
              <Item label={'Tipo de cobrança'} value={filter.charge_type} alias={ChargeTypes} />
              <Item label={'Afiliados'} value={formattedAffiliatesNames} />
              <Item label={'Tipo de ganho'} value={filter.type} alias={GainTypes} />
              <Item label={'Origem da venda'} value={filter.origin_sale} alias={OriginSales} />
              <Item label={'Cupom'} value={filter.coupon_id} alias={coupons} />
              <Item label={'Contrato'} value={filter.contract_id} />
              <Item label={'UTM'} value={filter.utms} />
              <Item label={'Filtro específico'} value={filter.infinity_funnel ? 'Funil Infinito' : null} />
              <Item label={'Filtro específico'} value={filter.courtesy_recovery ? 'Cortesias da recuperação de venda' : null} />
              <Item label={'Filtro específico'} value={filter.order_bump ? 'Order Bump' : null} />
              <Item label={'Filtro específico'} value={filter.recovery ? 'Somente vendas recuperadas' : null} />
              <Item label={'Filtro específico'} value={filter.chargeback ? 'Vendas com chargeback' : null} />
              <Item label={'Filtro específico'} value={filter.unlimited_installment ? 'Vendas de PSL' : null} />
              <Item label={'Filtro específico'} value={filter.fast_sale ? 'Venda Rápida' : null} />
              <Item label={'Filtro específico'} value={filter.upsell ? 'Upsell' : null} />
              <Item label={'Filtro específico'} value={filter.one_click_buy ? 'One Click Buy' : null} />
            </div>
          </Tooltip>
        )}
        <div className={classes.buttonReset}>
          <Button fullWidth onClick={resetFilter}>
            X Limpar
          </Button>
        </div>
      </div>
      <AdvancedButton />
    </div>
  );
};
export default ResultFilter;
